export default {
    "inks": [
        {
            "id": 1,
            "name": "HP 64XL High Yield Tri-color",
            "pages": 415,
            "cost": 43.99,
            "type": "color",
            "high_yield": true,
            "generic": false,
        },
        {
            "id": 2,
            "name": "HP 64XL High Yield Black",
            "pages": 600,
            "cost": 39.99,
            "type": "black",
            "high_yield": true,
            "generic": false,
        },
        {
            "id": 3,
            "name": "HP 64 Black",
            "pages": 200,
            "cost": 17.99,
            "type": "black",
            "high_yield": false,
            "generic": false,
        },
        {
            "id": 4,
            "name": "HP 64 Tri-color",
            "pages": 165,
            "cost": 23.99,
            "type": "color",
            "high_yield": false,
            "generic": false,
        },
        {
            "id": 5,
            "name": "HP 64XL High Yield Tri-color - Refilled",
            "pages": 415,
            "cost": 21.99,
            "type": "color",
            "high_yield": true,
            "generic": true,
        },
        {
            "id": 6,
            "name": "HP 64XL High Yield Black - Refilled",
            "pages": 600,
            "cost": 20.99,
            "type": "black",
            "high_yield": true,
            "generic": true,
        },
    ],
    "printers": [
        {
            "id": 1,
            "name": "HP ENVY Photo 7155",
            "inks": [1, 2, 3, 4, 5, 6]
        }
    ],
    "plans": [{
        "id": 36,
        "price": "FREE",
        "priceCents": 0,
        "pages": 15,
        "overageBlockPrice": "$1.00",
        "overageBlockPriceShortFormat": "$1",
        "overageBlockPriceCents": 100,
        "overageBlockSize": 10,
        "savings": "$39",
        "yearlyPrice": "$0",
        "standardCartridgeYearlyPrice": "$39",
        "rollover": 0,
        "isMicrobiz": false,
        "isHups": false,
        "waiver": 0,
        "legacy": false,
        "classification": "lups"
    }, {
        "id": 1,
        "price": "$2.99",
        "priceCents": 299,
        "pages": 50,
        "overageBlockPrice": "$1.00",
        "overageBlockPriceShortFormat": "$1",
        "overageBlockPriceCents": 100,
        "overageBlockSize": 10,
        "savings": "$96",
        "yearlyPrice": "$36",
        "standardCartridgeYearlyPrice": "$132",
        "rollover": 100,
        "isMicrobiz": false,
        "isHups": false,
        "waiver": 300,
        "legacy": false,
        "classification": "default"
    }, {
        "id": 2,
        "price": "$4.99",
        "priceCents": 499,
        "pages": 100,
        "overageBlockPrice": "$1.00",
        "overageBlockPriceShortFormat": "$1",
        "overageBlockPriceCents": 100,
        "overageBlockSize": 15,
        "savings": "$204",
        "yearlyPrice": "$60",
        "standardCartridgeYearlyPrice": "$264",
        "rollover": 200,
        "isMicrobiz": false,
        "isHups": false,
        "waiver": 300,
        "legacy": false,
        "classification": "default"
    }, {
        "id": 3,
        "price": "$9.99",
        "priceCents": 999,
        "pages": 300,
        "overageBlockPrice": "$1.00",
        "overageBlockPriceShortFormat": "$1",
        "overageBlockPriceCents": 100,
        "overageBlockSize": 20,
        "savings": "$672",
        "yearlyPrice": "$120",
        "standardCartridgeYearlyPrice": "$792",
        "rollover": 600,
        "isMicrobiz": false,
        "isHups": false,
        "waiver": 300,
        "legacy": false,
        "classification": "default"
    }, {
        "id": 94,
        "price": "$19.99",
        "priceCents": 1999,
        "pages": 700,
        "overageBlockPrice": "$1.00",
        "overageBlockPriceShortFormat": "$1",
        "overageBlockPriceCents": 100,
        "overageBlockSize": 20,
        "savings": "$1,608",
        "yearlyPrice": "$240",
        "standardCartridgeYearlyPrice": "$1,848",
        "rollover": 1400,
        "isMicrobiz": true,
        "isHups": false,
        "waiver": 700,
        "legacy": false,
        "classification": "microbiz"
    }],
    "partialSubscription": {
        "id": 107802401,
        "enrollmentKey": {"code": null, "months": 0, "retailer": null, "showMarketingOptin": false},
        "plan": {"id": null, "waiver": 0},
        "prepaid": {
            "balanceFromAppliedPrepaidKeys": "$0.00",
            "balance": null,
            "balanceCents": 0,
            "keys": [],
            "autoAppliedBalance": null
        },
        "printerId": null,
        "promoCode": {"code": null, "months": 0},
        "referredByCode": false,
        "xmo2": false,
        "freeTrialMonths": 0,
        "marketingOptin": false,
        "isPlanEditable": true,
        "autoAppliedCode": false,
        "requireBilling": true
    },
    "deltaPassword": "instant ink delta",
    "showDeltaModal": false,
    "radioPlanSelection": false,
    "showPrinterIneligibleLupsMessage": false,
    "initialSliderIndex": 1,
    "oobeOffer": null,
    "oobeIncentiveEligible": false,
    "maxOobeIncentiveFreeMonths": 0,
    "webServiceOptIn": null,
    "oobeFreeMonths": 0,
    "dynamicPromoMessage": null,
    "useEnrollmentPrepaidKeyIfPresentForLocale": true,
    "showFreeMobilePhotos": false,
    "enableEnvironmentalPromo": false,
    "showCallMeBackButton": false,
    "showCallMeBackOutOfHours": true,
    "isEmea": false
};